



















































import { Component, Vue, Prop } from "vue-property-decorator";

import { Plants, Plant, PlantImage } from "@/types";

@Component({
  components: {},
})
export default class PlantList extends Vue {
  get plants() {
    return this.$store.state.plants as Plants;
  }

  images(number: number) {
    const image = this.$store.state.images[number] as PlantImage;
    return `${image.gardenImages.length} + ${image.googleImages.length}`;
  }

  rowClass(plant: Plant) {
    if (!plant.localName) {
      return "table-danger";
    }

    const image = this.$store.state.images[plant.number];
    if (image.googleImages.length < 2) {
      return "table-danger";
    }
    if (image.gardenImages.length >= 1) {
      if (image.googleImages.length == 4) {
        return "table-success";
      }
      return "table-info";
    }
    if (image.googleImages.length > 4) {
      return "table-warning";
    }

    if (plant.localName == plant.name) {
      return "table-warning";
    }
    return "";
  }

  get orderedPlants() {
    return Object.keys(this.plants)
      .map((key) => +key)
      .sort((a: number, b: number) => a - b)
      .map((key) => this.plants[key]);
  }

  get types() {
    return Object.entries(this.plants)
      .map(([key, value]) => value.type)
      .filter((x, i, a) => a.indexOf(x) == i);
  }
}
